import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { FormProvider, RHFTextField } from 'src/components';
import { Paths } from 'src/config';
import { useCreateCourseLevelMutation } from 'src/redux/services/CourseLevelServices';
import * as Yup from 'yup';

const defaultValues = {
  name: '',
  slug: '',
};

const CourseCreateValidationSchema = Yup.object({
  name: Yup.string().required('نام اجباری می باشد'),
  slug: Yup.string().required('اسلاگ اجباری می باشد'),
}).required();

export const CourseLevelCreateForm = () => {
  const navigate = useNavigate();
  const [createCourseLevel, { isLoading }] = useCreateCourseLevelMutation();
  const methods = useForm({
    defaultValues,
    resolver: yupResolver(CourseCreateValidationSchema),
  });
  const { handleSubmit } = methods;

  async function onSubmit(values) {
    try {
      const body = {
        name: values.name,
        slug: values.slug,
      };
      await createCourseLevel(body).unwrap();
      enqueueSnackbar(`سطح دوره ${values.name} ایجاد شد`, { variant: 'success' });
      navigate(Paths.courseLevels.list.path);
    } catch (error) {
      console.log('CREATE COURSE LEVEL ERROR', error);
      if (error?.data?.err === `course level with slug ${values.slug} exists!`) {
        enqueueSnackbar(`سطح دوره با اسلاگ ${values.slug} قبلا ایجاد شده است`, { variant: 'warning' });
      } else {
        enqueueSnackbar(`سطح دوره ${values.name} ایجاد نشد`, { variant: 'error' });
      }
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <RHFTextField name={'name'} label={'نام'} />
        </Grid>
        <Grid item xs={6}>
          <RHFTextField name={'slug'} label={'اسلاگ'} />
        </Grid>
        <Grid item>
          <Button variant="contained" disabled={isLoading} type="submit">
            {Paths.courseLevels.create.title}
          </Button>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
